import { AudiencePageTemplate } from '@/components/AudiencePageTemplate'
import { getAudienceSegment } from '@/data/whoWeServe'

export default function ChurchesSacredMusicPage() {
  return <AudiencePageTemplate segment={getAudienceSegment('churches-sacred-music')} />
}
